import React from 'react'

import { Icon, Wrapper } from './pill-v2.styles'

import type { Props } from './pill.types'

export default function Pill({
  children,
  className,
  iconGlyph,
  iconStyle,
}: Props) {
  return (
    <Wrapper className={className}>
      {iconGlyph && <Icon iconStyle={iconStyle} glyph={iconGlyph} />}
      {children}
    </Wrapper>
  )
}
